require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-mei-lu-founder-and-ceo-jobfully-com.json") })
        }
      }, "path---blog-author-mei-lu-founder-and-ceo-jobfully-com");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-mei-lu-founder-and-ceo-jobfully-com!./.cache/json/blog-author-mei-lu-founder-and-ceo-jobfully-com.json
// module id = 682
// module chunks = 231608221292675